/**
 * Unified styling constants for all joint visualizations
 * This ensures consistent appearance across different joint types
 */

// Sphere sizes
export const JOINT_SPHERE_SIZES = {
  center: 0.018, // Main joint marker (teal)
  endpoint: 0.005, // Min/max position markers (red)
  glow: 0.04, // Highlight glow sphere (yellow)
};

// Sphere segment counts for smooth appearance
export const JOINT_SPHERE_SEGMENTS = {
  center: 12,
  endpoint: 12,
  glow: 12,
};

// Colors (as hex values)
export const JOINT_COLORS = {
  center: 0x0ddbb6, // Main joint marker (teal)
  minEndpoint: 0x009e89, // Min position marker (teal)
  maxEndpoint: 0xfa482d, // Max position marker (red)
  glow: 0x00ff00, // Highlight glow (green)
  arc: 0x07ab8e, //0x58C9B3,      // Range line/arc (green)
};

// Line properties
export const JOINT_LINE_PROPERTIES = {
  color: JOINT_COLORS.arc,
  linewidth: 2.5,
};

// Joint label styles
export const JOINT_LABEL_STYLES = {
  color: "#333333", // Dark gray text
  fontFamily: "Arial", // Font family
  fontSize: "12px",
  fontWeight: "bold",
  padding: "2px 4px",
  background: "rgba(240, 240, 240, 0.7)", // White background with transparency
  borderRadius: "2px",
  cursor: "pointer",
  userSelect: "none",
  pointerEvents: "auto",
  border: "1px solid rgba(0, 0, 0, 0.1)", // Subtle border for better definition
};

// Material properties
export const JOINT_MATERIALS = {
  center: {
    color: JOINT_COLORS.center,
    opacity: 1,
    transparent: false,
  },
  minEndpoint: {
    color: JOINT_COLORS.minEndpoint,
    opacity: 1,
    transparent: false,
  },
  maxEndpoint: {
    color: JOINT_COLORS.maxEndpoint,
    opacity: 1,
    transparent: false,
  },
  glow: {
    color: JOINT_COLORS.glow,
    opacity: 0.3,
    transparent: true,
  },
  arc: {
    color: JOINT_COLORS.arc,
    linewidth: JOINT_LINE_PROPERTIES.linewidth,
  },
};

// Reference percentages for joint marker sizes (relative to robot's largest dimension)
export const JOINT_SIZE_PERCENTAGES = {
  center: 0.018, // 1.8% of largest dimension
  endpoint: 0.005, // 0.5% of largest dimension
  glow: 0.04, // 4% of largest dimension
};
